import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import RouterHelper from '@shared/helpers/router.helper';
import AccountService from '@web/services/AccountService';

Vue.use(VueRouter);

const routerHelper = new RouterHelper();

const routes: Array<RouteConfig> = [
  {
    path: routerHelper.home().getRoute(),
    name: routerHelper.home().getName(),
    component: () => import(/* webpackChunkName: "layout" */
      '@web/views/layout/index.vue'),
    children: [
      {
        path: routerHelper.home().getRoute(),
        name: routerHelper.home().getName(),
        component: () => import(/* webpackChunkName: "home" */
          '@web/views/Home/Home.vue'),
      },
      {
        path: routerHelper.about().getRoute(),
        name: routerHelper.about().getName(),
        component: () => import(/* webpackChunkName: "about" */
          '@web/views/About/About.vue'),
      },
      {
        path: routerHelper.libraries().getRoute(),
        name: routerHelper.libraries().getName(),
        component: () => import(/* webpackChunkName: "libraries" */
          '@web/views/Libraries/Libraries.vue'),
      },
      {
        path: routerHelper.parents().getRoute(),
        name: routerHelper.parents().getName(),
        component: () => import(/* webpackChunkName: "parents" */
          '@web/views/Parents/Parents.vue'),
      },
      {
        path: routerHelper.terms().getRoute(),
        name: routerHelper.terms().getName(),
        component: () => import(/* webpackChunkName: "terms" */
          '@web/views/Terms/Terms.vue'),
      },
      {
        path: routerHelper.policy().getRoute(),
        name: routerHelper.policy().getName(),
        component: () => import(/* webpackChunkName: "policy" */
          '@web/views/Policy/Policy.vue'),
      },
      {
        path: routerHelper.faq().getRoute(),
        name: routerHelper.faq().getName(),
        component: () => import(/* webpackChunkName: "faq" */
          '@web/views/Faq/Faq.vue'),
      },
      {
        path: routerHelper.contacts().getRoute(),
        name: routerHelper.contacts().getName(),
        component: () => import(/* webpackChunkName: "contacts" */
          '@web/views/Contacts/Contacts.vue'),
      }
    ]
  },
  {
    path: routerHelper.login().getRoute(),
    name: routerHelper.login().getName(),
    component: () => import(/* webpackChunkName: "login" */
      '@web/views/Login/Login.vue')
  },
  {
    path: routerHelper.signup().getRoute(),
    name: routerHelper.signup().getName(),
    component: () => import(/* webpackChunkName: "signup" */
      '@web/views/Login/Signup.vue')
  },
  {
    path: routerHelper.signup().parent().getRoute(),
    name: routerHelper.signup().parent().getName(),
    component: () =>
      import(/* webpackChunkName: "signup-parent" */
        '@web/views/Login/SignupParent.vue')
  },
  {
    path: routerHelper.signup().organization().getRoute(),
    name: routerHelper.signup().organization().getName(),
    component: () => import(/* webpackChunkName: "signup-organization" */
      '@web/views/Login/SignupOrganization.vue')
  },
  {
    path: routerHelper.signup().greeting().getRoute(),
    name: routerHelper.signup().greeting().getName(),
    component: () => import(/* webpackChunkName: "greeting" */
      '@web/views/Login/Greeting.vue')
  },
  {
    path: routerHelper.signup().forgotPassword().getRoute(),
    name: routerHelper.signup().forgotPassword().getName(),
    component: () => import(/* webpackChunkName: "forgot-password" */
      '@shared/views/Login/ForgotPassword.vue'),
    props: {
      api: new AccountService()
    }
  },
  {
    path: routerHelper.expired().getRoute(),
    name: routerHelper.expired().getName(),
    component: () => import(/* webpackChunkName: "expired-subscribtion" */
      '@web/views/Login/ExpiredSubscribtion.vue')
  },
  {
    path: routerHelper.recoveryPassword().getRoute(),
    name: routerHelper.recoveryPassword().getName(),
    component: () => import(/* webpackChunkName: "reset-password" */
      '@shared/views/Login/ResetPassword.vue'),
    meta: {
      service: new AccountService()
    },
    beforeEnter: async ({ query: { email, token } }, from, next) => {
      console.log(token);
      if (!(email && token)) {
        return next(routerHelper.home().getRoute());
      }

      try {
        const api = new AccountService();
        await api.accountVerifyResetPasswordToken({
          email,
          token: window.encodeURIComponent(token as string)
        });
        return next();
      } catch (e) {
        return next({
          name: routerHelper.signup().forgotPassword().getName(),
          params: {
            error: `Sorry, you change password link has expired.
            Please enter your email below and we will
            send you new request`
          }
        });
      }
    }
  },
  {
    path: routerHelper.verifyEmail().getRoute(),
    name: routerHelper.verifyEmail().getName(),
    component: () =>
      import(/* webpackChunkName: "verify-email" */ '@shared/views/Login/ResetPassword.vue'),
    meta: {
      service: (() => {
        const service = new AccountService();
        return {
          accountResetPassword: service.accountVerifyEmail.bind(service),
          resendEmailToken: service.resendEmailToken.bind(service),
          accountOrganizationAndParentLogin: service.accountOrganizationAndParentLogin.bind(service)
        };
      })()
    },
    beforeEnter: async ({ query: { email, token } }, from, next) => {
      if (!(email && token)) {
        return next(routerHelper.home().getRoute());
      }

      return next();
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
